module.exports = __webpack_public_path__ + "facebook.svg?c0cd138271276bb33a87c2d174015455";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/social/facebook.svg
// module id = 35
// module chunks = 0